module.exports = __webpack_public_path__ + "static/media/hoyuk.faf8ceef.jpg";